import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';

import recordingAnimation from '@smart-tv/scaffold/lottie/recording.json';

interface Props {
  className?: string;
}

const RecordingAnimation: React.FC<Props> = ({ className }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const animation = lottie.loadAnimation({
      container: containerRef.current,
      animationData: recordingAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true
    });

    return () => animation.destroy();
  }, []);

  return <div ref={containerRef} className={className} role="img" aria-label="Recording" />;
};

export default React.memo(RecordingAnimation);
